var _title, _desc, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "584px",
    height: "241px",
    viewBox: "0 0 584 241",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "404 image")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XL-/-1440+",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 404,
    transform: "translate(-735.000000, -247.000000)",
    stroke: "#00C8FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "404-image",
    transform: "translate(738.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(188.000000, 31.000000)",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,103 C206,159.886594 159.884554,206 103,206 C46.1154455,206 0,159.886594 0,103 C0,46.1134059 46.1154455,0 103,0 C159.884554,0 206,46.1134059 206,103 Z",
    id: "Stroke-1",
    opacity: 0.457914807
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.814634,102.998269 C167.814634,137.965717 138.795484,166.307317 103,166.307317 C67.2045164,166.307317 38.1853659,137.965717 38.1853659,102.998269 C38.1853659,68.0342826 67.2045164,39.6926829 103,39.6926829 C138.795484,39.6926829 167.814634,68.0342826 167.814634,102.998269 Z",
    id: "Stroke-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.585366,102.497561 C120.585366,111.932411 112.711997,119.580488 103,119.580488 C93.2880029,119.580488 85.4146341,111.932411 85.4146341,102.497561 C85.4146341,93.0627112 93.2880029,85.4146341 103,85.4146341 C112.711997,85.4146341 120.585366,93.0627112 120.585366,102.497561 Z",
    id: "Stroke-1",
    opacity: 0.457914807
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.396077,0.245437975 L53.5768774,146.991438 C52.6105677,149.109159 54.1684129,151.511261 56.5021419,151.511261 L85.839871,151.511261",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.138013,237.22856 L100.030645,189.823868 C100.024568,187.599252 98.2134968,185.798181 95.9790323,185.798181 L6.08994839,185.798181 C1.71420645,185.798181 -1.22726452,181.330797 0.516954839,177.335362 L77.8541419,0.245437975",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(132.696774, 184.796599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.750156129,51.4235224 L0.750156129,4.95667848 C0.750156129,2.72802869 2.56527871,0.922923207 4.80176903,0.922923207 L23.0340271,0.922923207",
    id: "Stroke-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(132.696774, 116.214321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.750156129,0.0015814346 L0.750156129,30.4140793 C0.750156129,33.1106447 2.94613032,35.2969401 5.65463355,35.2969401 L23.0340271,35.2969401",
    id: "Stroke-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.034027,116.215902 L101.034027,147.477505 C101.034027,149.704138 99.2189045,151.511261 96.9824142,151.511261 L78.7501561,151.511261",
    id: "Stroke-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    transform: "translate(425.000000, 0.000000)",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.396077,0.245437975 L53.5768774,146.991438 C52.6105677,149.109159 54.1684129,151.511261 56.5021419,151.511261 L85.839871,151.511261",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.138013,237.22856 L100.030645,189.823868 C100.024568,187.599252 98.2134968,185.798181 95.9790323,185.798181 L6.08994839,185.798181 C1.71420645,185.798181 -1.22726452,181.330797 0.516954839,177.335362 L77.8541419,0.245437975",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(132.696774, 184.796599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.750156129,51.4235224 L0.750156129,4.95667848 C0.750156129,2.72802869 2.56527871,0.922923207 4.80176903,0.922923207 L23.0340271,0.922923207",
    id: "Stroke-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(132.696774, 116.214321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.750156129,0.0015814346 L0.750156129,30.4140793 C0.750156129,33.1106447 2.94613032,35.2969401 5.65463355,35.2969401 L23.0340271,35.2969401",
    id: "Stroke-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.034027,116.215902 L101.034027,147.477505 C101.034027,149.704138 99.2189045,151.511261 96.9824142,151.511261 L78.7501561,151.511261",
    id: "Stroke-11"
  }))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.bcdb64a3.svg";
export { ForwardRef as ReactComponent };